module.exports = __webpack_public_path__ + "img/DieBand.829ca326.svg";